export interface HMPayState {
  error?: string
  isLoading: boolean
  isLoadMoreUsed: boolean
  isFailedToLoad: boolean
  isKlarnaAuthRequested: boolean
  isFetchingKlarnaProfile: boolean
  isOrderListPopulated: boolean
  loadingOrderId: string
  operations: Object
  subscription: Object
  monthlyInvoices: MonthlyInvoices
  selectedTab: string
  orders: Orders
}

interface MonthlyInvoices {
  isLoading: boolean
  error: boolean
  invoices: Object
  filters: {
    [key: string]: MonthlyFilter
  }
}

interface Orders {
  filters: {
    [key: string]: OrdersFilter
  }
  invoices: Object
}

interface MonthlyFilter {
  expandedOrderId: string | null
  expandedMonthlyInvoiceId: string | null
  monthlyInvoiceIds: Array<Object>
}

interface OrdersFilter {
  expandedOrderId: string | null
  isLoading: boolean
  isLoadingMore: boolean
  isLoadMoreUsed: boolean
  nextOffset: number
  totalNumberOfOrders: number
  orderIds: Array<Object>
}

export enum Errors {
  OAUTH_EXPIRED = 'OAUTH_EXPIRED',
}
export interface KlarnaOrderOperation {
  label: string
  token: string
  type: string
}
